import type { CustomFilterConfig } from 'hooks/useDirectoryData/types';

import { localize } from './localize';

export function sortOptionsByLabel(filter: CustomFilterConfig, locale: string): CustomFilterConfig {
  const options = [...filter.options].sort((a, b) => {
    return (localize(a.label, locale) ?? a.value).localeCompare(localize(b.label, locale) ?? b.value, locale);
  });

  return { ...filter, options };
}
